import {
  Building2,
  ClipboardList,
  Code2,
  Link2,
  MessageSquareText,
  Tags,
  Ticket,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { MessageBusGraphIcon } from '@/components/shared/MessageBusGraphIcon';
import { ArchitectureObservabilityIcon } from '@/components/shared/ArchitectureObservabilityIcon';

export type BackofficeNavigationTopLevelItemId =
  | 'organizations'
  | 'users'
  | 'studies'
  | 'interviews'
  | 'vouchers'
  | 'links'
  | 'tags'
  | 'developer';

export type BackofficeNavigationChildItemId = 'developer-messagebus' | 'developer-observability';

export type BackofficeNavigationItemId =
  BackofficeNavigationTopLevelItemId | BackofficeNavigationChildItemId;

export type BackofficeNavigationChildItem = {
  id: BackofficeNavigationChildItemId;
  label: string;
  to: string;
  end?: boolean;
  Icon: LucideIcon;
};

export type BackofficeNavigationItem = {
  id: BackofficeNavigationTopLevelItemId;
  label: string;
  to: string;
  end?: boolean;
  Icon: LucideIcon;
  children?: BackofficeNavigationChildItem[];
};

export const BACKOFFICE_NAVIGATION_ITEMS: BackofficeNavigationItem[] = [
  {
    id: 'organizations',
    label: 'Organizations',
    to: '/organizations',
    Icon: Building2,
  },
  {
    id: 'users',
    label: 'Users',
    to: '/users',
    Icon: Users,
  },
  {
    id: 'studies',
    label: 'Studies',
    to: '/projects',
    end: false,
    Icon: ClipboardList,
  },
  {
    id: 'interviews',
    label: 'Interviews',
    to: '/interviews',
    Icon: MessageSquareText,
  },
  {
    id: 'vouchers',
    label: 'Vouchers',
    to: '/vouchers',
    Icon: Ticket,
  },
  {
    id: 'links',
    label: 'Links',
    to: '/links',
    Icon: Link2,
  },
  {
    id: 'tags',
    label: 'Tags',
    to: '/tags',
    Icon: Tags,
  },
  {
    id: 'developer',
    label: 'Developer',
    to: '/developer',
    Icon: Code2,
    children: [
      {
        id: 'developer-messagebus',
        label: 'Message bus',
        to: '/developer/messagebus',
        Icon: MessageBusGraphIcon,
      },
      {
        id: 'developer-observability',
        label: 'Architecture observability',
        to: '/developer/observability',
        Icon: ArchitectureObservabilityIcon,
      },
    ],
  },
];
